import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import Dashboard from './Dashboard'
import Page from './Pages/Page'
import Eventsdetails from './Events/eventsDetails'
import Eventsticketbook from './Events/eventsBookTicket'
import Ticketconfirmation from './Events/ticketConfirmation'
import Myticket from './MyTicket'
import TicketDetails from './MyTicket/ticketDetails'
import SellTicketDetails from './MyTicket/sellTicketDetails'
import Sellticketconfirmation from './MyTicket/sellticketConfirmation'
import ResellMKT from './ResellMKT'
import Eventresellticketlist from './ResellMKT/eventsResellticketlist'
import Eventresellticketbooking from './ResellMKT/eventsResellticketbooking'
import Eventresellticketconfirmation from './ResellMKT/eventsResellticketconfirmation'
import Myresellticketlist from './ResellMKT/myResellticketlist'
import Profile from './Pages/profile'
import Changepassword from './Pages/channgePassword'
import MyWallet from './MyWallet'
import Ticketdetails from './MyWallet/ticketDetails'
import ShareableTicketDetails from './MyTicket/ShareableTicketDetails';
import WalletBalance from './MyWallet/walletBalance';
import Login from '../views/Login/Login';

const Markup = () => {
  const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));

    const allroutes = [
      // Dashboard &  Events
      { url: '*', component: <Dashboard /> },

      { url: 'dashboard', component: <Dashboard /> },
      { url: 'dashboard/events-details/:e_id', component: <Eventsdetails /> },
      { url: 'dashboard/events-details/book-ticket/:e_id', component: <Eventsticketbook /> },
      { url: 'dashboard/events-details/book-ticket/confirmation/:ut_id', component: <Ticketconfirmation /> },
      
    // My Tickets
    { url: '/my-tickets', component: <Myticket /> },
    { url: '/my-tickets/ticket-details/:ut_id', component:<TicketDetails /> },
    { url: '/my-tickets/resell-ticket-details/:ut_id', component:<SellTicketDetails /> },
    { url: '/my-tickets/events-details/confirmation/:r_id', component: <Sellticketconfirmation /> },
    { url: '/ticket/view/:token', component: <ShareableTicketDetails /> },
  
    //Resell MKT
    { url: '/resell-market', component: <ResellMKT /> },
    { url: '/resell-market/ticket-list/:e_id', component: <Eventresellticketlist /> },
    { url: '/resell-market/ticket-list/book-ticket/:r_id', component: <Eventresellticketbooking /> },
    { url: '/resell-market/ticket-list/book-ticket/confirmation/:ut_id', component: <Eventresellticketconfirmation /> },

    { url: '/my-resell-tickets', component: <Myresellticketlist /> },


    //profile
    { url: '/profile', component: <Profile /> },
    { url: '/change-password', component: <Changepassword /> },
    { url: '/pages/:slug', component: <Page /> },


    // Wallet
    { url: '/my-wallet', component: <MyWallet /> },
    { url: '/my-wallet/ticket-details', component: <Ticketdetails /> },
    { url: '/wallet-balance', component: <WalletBalance /> },

    ]

    const guestroutes = [
      // Dashboard &  Events
    
      { url: 'dashboard', component: <Dashboard /> },
      { url: 'dashboard/events-details/:e_id', component: <Eventsdetails /> },
      { url: 'dashboard/events-details/book-ticket/:e_id', component: <Eventsticketbook /> },
      
    // My Tickets
    // { url: '/my-tickets', component: <Myticket /> },
    // { url: '/my-tickets/resell-events-details', component:<Myeventsdetails /> },
    // { url: '/my-tickets/events-details/confirmation', component: <Sellticketconfirmation /> },
  
    //Resell MKT
    { url: '/resell-market', component: <ResellMKT /> },
    { url: '/resell-market/ticket-list/:e_id', component: <Eventresellticketlist /> },
    { url: '/resell-market/ticket-list/book-ticket/:r_id', component: <Eventresellticketbooking /> },
    // { url: '/resell-market/ticket-list/book-ticket/confirmation', component: <Eventresellticketconfirmation /> },

    // { url: '/my-resell-tickets', component: <Myresellticketlist /> },


    //profile
    // { url: '/profile', component: <Profile /> },
    // { url: '/change-password', component: <Changepassword /> },
    { url: '/pages/:slug', component: <Page /> },
    { url: '*', component: <Login /> },



    // Wallet
    // { url: '/my-wallet', component: <MyWallet /> },
    // { url: '/my-wallet/ticket-details', component: <Ticketdetails /> },

    ]
  
    if(TokenDetails.guestMode == false){
      return (
        <>
          <Routes>
            <Route element={<MainLayout />} > 
              {allroutes.map((data, i) => (
                <Route key={i} exact path={`${data.url}`} element={data.component} />
              ))}
            </Route>
          </Routes>
        </>
      )
    }else{
      return (
        <>
          <Routes>
            <Route element={<MainLayout />} > 
              {guestroutes.map((data, i) => (
                <Route key={i} exact path={`${data.url}`} element={data.component} />
              ))}
            </Route>
          </Routes>
        </>
      )
    }
    
  }
  
  function MainLayout() {
    return (
      <div id="main-wrapper" className="show">
       
        <div className="content-body" style={{ minHeight: window.screen.height - 230 }}>
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
       
      </div>
    )
  };
  
  export default Markup;